import { Navigate, useLocation } from 'react-router-dom';
import Loading from '../Loading/Loading';
import { useAuth } from '../../contexts/AuthContext';

const PrivateRoute = ({ children }) => {
    const { isAuthenticated, isLoading } = useAuth();
    const location = useLocation();

    // Pendant la vérification
    if (isLoading) {  // isLoading du context
        return <Loading />;
    }

    if (!isAuthenticated) {  // isAuthenticated du context
        const currentPath = location.pathname;
        if (currentPath !== '/connexion') {
            localStorage.setItem('redirectAfterLogin', currentPath);
        }
        return <Navigate to="/connexion" replace />;
    }

    return children;
};

export default PrivateRoute;